import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { Subject, Subscription, throttleTime } from 'rxjs'
import {
  SettlingService,
  SettlingGame,
  settlingGameNull,
  Card,
} from 'game-services'
import {
  DashboardComponent,
  DashboardUserAction,
} from '../dashboard/dashboard.component'
import { playerScoreCardNull } from 'game-play-services'

@Component({
  selector: 'sans-settling',
  standalone: true,
  imports: [DashboardComponent],
  templateUrl: './settling.component.html',
  styleUrl: './settling.component.scss',
})
export class SettlingComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public settlingGame: SettlingGame = settlingGameNull
  @Input() public userPlayerScoreCard = playerScoreCardNull
  @Input() public leftOpponentPlayerScoreCard = playerScoreCardNull
  @Input() public rightOpponentPlayerScoreCard = playerScoreCardNull
  @Output() public gameUpdated = new EventEmitter<void>()

  public continueLabel = $localize`:Settling component|Continue label:Continue`
  public talonCards: Card[] = []
  public userCards: Card[] = []
  public rightOpponentCards: Card[] = []
  public leftOpponentCards: Card[] = []
  public userActions: DashboardUserAction[] = []

  private continueClicks = new Subject<void>()
  private continueClicksSubscription = new Subscription()

  public constructor(private readonly settlingService: SettlingService) {}

  public async ngOnInit(): Promise<void> {
    this.continueClicksSubscription = this.continueClicks
      .pipe(throttleTime(1000))
      .subscribe(async () => {
        await this.settlingService.confirmResults(
          this.settlingGame.gamePlayGameId,
        )
        this.gameUpdated.emit()
      })
  }

  public ngOnChanges(): void {
    this.talonCards = this.settlingGame.getTalonCards()
    this.userCards = this.settlingGame.user.originalCards
    this.rightOpponentCards = this.settlingGame.rightOpponent.originalCards
    this.leftOpponentCards = this.settlingGame.leftOpponent.originalCards

    this.userActions = [
      {
        buttonLabel: this.continueLabel,
        value: '',
      },
    ]
  }

  public ngOnDestroy(): void {
    this.continueClicksSubscription.unsubscribe()
  }

  public async onUserActionSelected(_: DashboardUserAction): Promise<void> {
    this.continueClicks.next()
  }
}
